/* eslint-disable @next/next/no-img-element */
import React from 'react';
import styles from './ImageBlock.module.scss';

export function ImageBlock() {
  return (
    <figure className={styles.root}>
      <img
        src="/assets/images/MainImage.svg"
        alt="Main Image"
        style={{  width: 'auto', height: '20dvw', objectFit: 'contain', border: 'var(--border-bold) !important', borderRadius: '1dvw' }}
      />
    </figure>
  );
}
